import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';

interface AsyncState {
  isLoading: {
    logs: boolean;
    orderData: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface AuthState extends AsyncState {
  // usersData: any;
  oneOrderData: any;
  // userPermissionEditDetails: any;
  userStatusEditDetails: any;
  addUserOutPutData: any;
  activitiesLogsData: any;
}

const initialState: AuthState = {
  isLoading: {
    logs: true,
    orderData: true,
  },
  isSuccess: false,
  isError: false,
  // usersData: null,
  oneOrderData: null,
  // userPermissionEditDetails: null,
  userStatusEditDetails: null,
  addUserOutPutData: null,
  activitiesLogsData: null,
};

export const getOrder = createAsyncThunk('order-details', async (data: any, thunkAPI) => {
  try {
    return await Service.getOneOrder(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue('Unable to login');
  }
});

export const editStatus = createAsyncThunk('order/editStatus', async (data: any, thunkAPI) => {
  try {
    return await Service.editOrderStatus(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue('Unable to edit');
  }
});

export const orderDetailsSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrder.pending, (state) => {
        state.isLoading.orderData = true;
        state.isError = false;
        state.isSuccess = false;
        state.oneOrderData = null;
      })
      .addCase(getOrder.fulfilled, (state, action) => {
        state.isLoading.orderData = false;
        state.isError = false;
        state.isSuccess = true;
        state.oneOrderData = action.payload;
      })
      .addCase(getOrder.rejected, (state) => {
        state.isLoading.orderData = false;
        state.isError = true;
        state.isSuccess = false;
        state.oneOrderData = null;
      })

      // EDIT_STATUS
      .addCase(editStatus.pending, (state) => {
        state.isLoading.orderData = true;
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(editStatus.fulfilled, (state, action) => {
        state.isLoading.orderData = false;
        state.isError = false;
        state.isSuccess = true;
        state.userStatusEditDetails = action.payload;
      })
      .addCase(editStatus.rejected, (state) => {
        state.isLoading.orderData = false;
        state.isError = true;
        state.isSuccess = false;
      });
  },
});


export default orderDetailsSlice.reducer;
